import React, { useEffect, useState, useMemo } from 'react';
import { debounce as _debounce } from 'lodash';

import { chargerDetailsInputDebounce } from '../../constants/commonConstants';
import TextField from '../TextField/TextField';

function RenderInput({
  debounce,
  input,
  meta: { touched, error },
  label,
  disabled,
  type,
  required,
  readOnly,
  floatingLabelText,
  className,
  multiLine,
  minRows,
  maxRows,
  fixedValue,
  fullWidth,
  autoComplete,
  id,
  helperText,
  inputProps,
  valuePostProcessor,
  trimDataOnBlur,
}) {
  const [value, setValue] = useState(input.value);

  const forwardChange = useMemo(
    () =>
      _debounce((value) => {
        setValue(value);
        input.onChange(value);
      }, debounce || chargerDetailsInputDebounce),
    [debounce],
  );

  useEffect(() => {
    if (input.value !== value) {
      setValue(input.value);
    }
  }, [input.value]);

  const handleChange = (evt) => {
    const currentInputValue = valuePostProcessor ? valuePostProcessor(evt.target.value) : evt.target.value;
    const eventValue = evt.target.value;

    // will show e.g 0.00000028 except 2.8e-7
    if (type === 'number' && eventValue.includes('e-')) {
      const toFix = Number(eventValue.split('e-')[1]) + 1;
      const readableNumber = Number(eventValue).toFixed(toFix);

      setValue(readableNumber);
      forwardChange(readableNumber);
    } else {
      setValue(eventValue);
      forwardChange(currentInputValue);
    }
  };

  const handleBlur = useMemo(() => {
    if (trimDataOnBlur) {
      return _debounce((evt) => {
        setValue(evt.target.value.trim());
        input.onChange(evt.target.value.trim());
      }, debounce || chargerDetailsInputDebounce);
    }
  }, [trimDataOnBlur, debounce]);

  const errorText = touched && error ? error : '';
  const labelText = floatingLabelText || label || '';

  return (
    <div data-field-name={`${input.name}`} className="contents">
      <TextField
        id={id}
        required={required}
        type={type}
        name={input.name}
        multiline={multiLine}
        minRows={minRows}
        maxRows={maxRows}
        className={className}
        value={fixedValue || value}
        disabled={disabled || readOnly}
        onChange={handleChange}
        fullWidth={fullWidth}
        label={labelText}
        error={!!errorText}
        helperText={errorText || helperText}
        autoComplete={autoComplete}
        inputProps={inputProps}
        onBlur={handleBlur}
      />
    </div>
  );
}

export default RenderInput;
